import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
//import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { login_routes } from "../../router/login_routes";
import UserService from "../../network/services/UserService";
import { Button, Toast } from 'react-bootstrap';
import { ids } from "../../../core/common/selectoption/selectoption";
import { setToken, signIn } from "../../network/auth/Auth";

type PasswordField = "password";

const Login2 = () => {
  const routes = login_routes;
  const navigation = useNavigate();

  const navigationPath = () => {
    navigation(routes.adminDashboard);
  };
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };



  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleUsername = (e: any) => {
    setUsername(e.target.value);
  };
  const handlePassword = (e: any) => {
    setPassword(e.target.value);
  };

  const handleSubmit = async () => {
    setIsLoading(true)
    const requestBody = {
      "phone": username,
      "password": password,
    }
    UserService.login(requestBody, async (data: any) => {
      console.log(data);

      if (data && data.success === true) {
        signIn(data.data);
        setToken(data.data.token);
        setShowSuccessToast(true);
        setIsLoading(false);
        setSuccessMessage(data.message);

        const userRole = data.data.roles.find((item: any) => item.name === 'admin');

        try {
          // Utilisation correcte de la promesse
          if (userRole) {
            console.log('admin');
            navigation('/admin-dashboard');
          } else {
            console.log('no admin');
            // navigation.navigate('stack', { screen: 'vehicle' });
          }

        } catch (error) {
          console.error('Erreur lors de la mise à jour Firebase:', error);
        }


      } else {
        setShowDangerToast(true);
        setErrorMessage(data.message);
        setIsLoading(false);
      }
    });

  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);


  return (
    <>
      <div className="container-fuild">
        <div className="login-wrapper w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
          <div className="row">
            <div className="col-lg-6">
              <div className="d-lg-flex align-items-center justify-content-center bg-light-300 d-lg-block d-none flex-wrap vh-100 overflowy-auto bg-01">
                <div>
                  <img
                    src="https://preskool.dreamstechnologies.com/react/template/assets/img/authentication/authentication-06.svg"
                    alt="Img"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                <div className="col-md-8 mx-auto p-4">
                  <form>
                    <div>
                      {/*  <div className=" mx-auto mb-5 text-center">
                        <img
                          src="assets/img/authentication/logox.png"
                          className="img-fluid"
                          alt="Logo"
                        />
                      </div> */}
                      <div className="card">
                        <div className="card-body p-4">
                          {/*  <div className=" mb-4">
                            <h2 className="mb-2">Welcome</h2>
                            <p className="mb-0">
                              Please enter your details to sign in
                            </p>
                          </div> */}
                          <div className="mt-4">
                            <div className="d-flex align-items-center justify-content-center flex-wrap">
                              {/* <div className="text-center me-2 flex-fill">
                                <Link
                                  to="#"
                                  className="bg-primary br-10 p-2 btn btn-primary  d-flex align-items-center justify-content-center"
                                >
                                  <img
                                    className="img-fluid m-1"
                                    src="assets/img/icons/facebook-logo.svg"
                                    alt="Facebook"
                                  />
                                </Link>
                              </div> */}
                              <div className="text-center me-2 flex-fill">
                                <Link
                                  to="#"
                                  className=" br-10 p-2 d-flex align-items-center justify-content-center"
                                >
                                  <img
                                    src="assets/img/icon.png"
                                    className="img-fluid"
                                    alt="Logo"
                                    style={{ width: "150px", height: "150px" }}
                                  />
                                </Link>
                              </div>
                              {/*  <div className="text-center flex-fill">
                                <Link
                                  to="#"
                                  className="bg-dark br-10 p-2 btn btn-dark d-flex align-items-center justify-content-center"
                                >
                                  <img
                                    className="img-fluid  m-1"
                                    src="assets/img/icons/apple-logo.svg"
                                    alt="Apple"
                                  />
                                </Link>
                              </div> */}
                            </div>
                          </div>
                          <div className="login-or">
                            <span className="span-or">Login</span>
                          </div>
                          <div className="mb-3 ">
                            <label className="form-label">Phone</label>
                            <div className="input-icon mb-3 position-relative">
                              <span className="input-icon-addon">
                                <i className="ti ti-phone" />
                              </span>
                              <input type="text" className="form-control" onChange={handleUsername} placeholder="Phone" />
                            </div>
                            <label className="form-label">Password</label>
                            <div className="pass-group">
                              <input
                                type={
                                  passwordVisibility.password
                                    ? "text"
                                    : "password"
                                }
                                className="pass-input form-control"
                                onChange={handlePassword}
                                placeholder="Password"
                              />
                              <span
                                className={`ti toggle-passwords ${passwordVisibility.password
                                  ? "ti-eye"
                                  : "ti-eye-off"
                                  }`}
                                onClick={() =>
                                  togglePasswordVisibility("password")
                                }
                              ></span>
                            </div>
                          </div>
                          <div className="form-wrap form-wrap-checkbox mb-3">
                            <div className="d-flex align-items-center">
                              <div className="form-check form-check-md mb-0">
                                <input
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                />
                              </div>
                              <p className="ms-1 mb-0 ">Remember Me</p>
                            </div>
                            <div className="text-end ">
                              <Link
                                to={routes.forgotPassword}
                                className="link-danger"
                              >
                                Forgot Password?
                              </Link>
                            </div>
                          </div>
                          <div className="mb-3">
                            <span
                              onClick={handleSubmit}
                              className="btn btn-primary w-100"
                            >
                              {isLoading ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm align-middle me-1"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  Loading...
                                </>
                              ) : "Sign In"}

                            </span>


                          </div>
                          <div className="text-center">
                            <h6 className="fw-normal text-dark mb-0">
                              Don’t have an account?{" "}
                              <Link to={routes.register2} className="hover-a ">
                                {" "}
                                Create Account
                              </Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div className="mt-5 text-center">
                        <p className="mb-0 ">Copyright © 2024 - Tokoss</p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Toast
        show={showDangerToast}
        onClose={handleDangerToastClose}
        id="dangerToast"
        className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ minWidth: "200px!important" }}
      >
        <Toast.Header closeButton className="bg-danger text-fixed-white">
          <strong className="me-auto">Message</strong>
          <span
            className="cursor-pointer"
            onClick={handleDangerToastClose}
            aria-label="Close"
            style={{ cursor: "pointer" }}
          />
        </Toast.Header>
        <Toast.Body>
          {/* Add your toast content here */}
          {errorMessage}
        </Toast.Body>
      </Toast>

      <Toast
        show={showSuccessToast}
        onClose={handleSuccessToastClose}
        id="successToast"
        className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >

        <Toast.Body>
          {/* Add your toast content here */}
          {successMessage}
        </Toast.Body>
      </Toast>
    </>
  );
};

export default Login2;
